<template>
  <v-navigation-drawer 
    id="core-navigation-drawer" 
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'" 
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl" 
    :src="barImage" 
    mobile-break-point="960" 
    app width="260" 
    v-bind="$attrs"
    >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <v-list-item>
        <v-list-item-avatar class="align-self-center" size="50" color="white">
          <v-img :src="dimfer" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="text-h4" v-text="profile.title" />
        </v-list-item-content>
      </v-list-item>

    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <template v-for="(item, i) in computedItems">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">

        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item" />
      </template>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import dimfer from "@/assets/dimfer.png"
import {
  mapState,
} from 'vuex'

export default {
  name: 'DashboardCoreDrawer',
  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dimfer,
    items: [],
    accions: [],
    admins: [
      ['Management', 'mdi-account-multiple-outline'],
      ['Settings', 'mdi-cog-outline'],
    ],
    cruds: [
      ['Create', 'mdi-plus-outline'],
      ['Read', 'mdi-file-outline'],
      ['Update', 'mdi-update'],
      ['Delete', 'mdi-delete'],
    ],
  }),
  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
    computedItems() {
      return this.items.map(this.mapItem)
    },
    profile() {
      return {
        avatar: true,
        title: 'DIMFER',
      }
    },
  },
 mounted() {
  if (this.$store.state.chargedPermissions) {
    this.buildMenu();
  } else {
    const unwatch = this.$watch(
      () => this.$store.state.chargedPermissions,
      (val) => {
        if (val) {
          this.buildMenu();
          unwatch(); 
        }
      }
    );
  }
},
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      }
    },
    buildMenu() {
    // Usuarios
    const childrenUsuarios = [];

    if (this.$store.getters.hasPermission('Usuarios', 'VerMódulo')) {
      childrenUsuarios.push({
        title: 'Usuarios',
        icon: 'mdi-account-box',
        to: 'usuarios',
      });
    }
    if (this.$store.getters.hasPermission('Perfiles', 'VerMódulo')) {
      childrenUsuarios.push({
        title: 'Perfiles',
        icon: 'mdi-account',
        to: 'perfiles',
      });
    }

    if (childrenUsuarios.length > 0) {
      this.items.push({
        title: 'Usuarios',
        icon: 'mdi-account-multiple',
        group: '/usuarios',
        children: childrenUsuarios,
      });
    } else {
      console.log("Sin acceso a Usuarios y/o Perfiles");
    }

    // Proyectos
    const childrenProyectos = [
      {
        title: 'dashboard',
        icon: 'mdi-view-dashboard',
        to: 'dashboard',
      },
    ];

    if (this.$store.getters.hasPermission('Proyectos', 'Prospección')
        || this.$store.getters.hasPermission('Proyectos', 'Crear')
        || this.$store.getters.hasPermission('Proyectos', 'Editar')
        || this.$store.getters.hasPermission('Proyectos', 'Eliminar')
        || this.$store.getters.hasPermission('Proyectos', 'Descargar')
        || this.$store.getters.hasPermission('Proyectos', 'VerTodo')) {
      childrenProyectos.push({
        title: 'Prospección',
        icon: 'mdi-clipboard-outline',
        to: 'prospeccion',
      });
    }
    if (this.$store.getters.hasPermission('Proyectos', 'Aprobación') 
        || this.$store.getters.hasPermission('Proyectos', 'VerTodo')) {
      childrenProyectos.push({
        title: 'Aprobación',
        icon: 'mdi-clipboard-outline',
        to: 'aprobacion',
      });
    }
    if (this.$store.getters.hasPermission('Proyectos', 'Negociación') 
        || this.$store.getters.hasPermission('Proyectos', 'VerTodo')) {
      childrenProyectos.push({
        title: 'Negociación',
        icon: 'mdi-cash',
        to: 'negociacion',
      });
    }
    childrenProyectos.push({
      title: 'Mapas',
      icon: 'mdi-map',
      to: 'mapas',
    });

    this.items.push({
      icon: 'mdi-view-dashboard',
      title: 'Proyectos',
      group: '/proyectos',
      children: childrenProyectos,
    });

    // Contactos
    if (this.$store.getters.hasPermission('Contactos', 'VerMódulo')) {
      this.items.push({
        title: 'Contactos',
        icon: 'mdi-account-box',
        to: '/contactos',
      });
    } else {
      console.log("No tiene permiso para ver Contactos");
    }

    // Visitas
    if (this.$store.getters.hasPermission('Visitas', 'VerMódulo')) {
      this.items.push({
        title: 'Visitas',
        icon: 'mdi-calendar-search',
        to: '/visitas',
      });
    } else {
      console.log("No tiene permiso para ver Visitas");
    }

    // Visitas
    if (this.$store.getters.hasPermission('Visitas', 'VerHistorialDeCambios')) {
      this.items.push({
        title: 'Historial de Cambios',
        icon: 'mdi-calendar',
        to: '/logGlobal',
      });
    } else {
      console.log("No tiene permiso para ver el historial de cambios ");
    }
  }
  },
}
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
